import type { FaireProductEntity } from "../../entity_types/product";

export const p_df7dvfex6j: FaireProductEntity = {
  token: "p_df7dvfex6j",
  type: "product",
  name: "24K Gold Filled 1.5mm Mariner Scroll Link Minimalist 24 Inch Layering Necklace | WA-2322 Clearance Pricing",
  brandToken: "b_374b66mxaz",
  brandName: "Aim Eternal",
  imageUrl:
    "https://cdn.faire.com/fastly/ebea2291f0ccdb2588c54c61a1503cf090c8a3cbb8a55970ec7533ea91a96be0.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ad5e482c69d80b42ac92b7e3e2b96b2c261773eb433571828e811d9fb14ca0de.jpeg",
    "https://cdn.faire.com/fastly/bcdc9ce842905b968d1308ebdd40e0ba20b404e263f71aeab6d4b024f5c0017a.jpeg",
  ],
  priceDollars: 5.54,
  description:
    "Material: Brass, Gold Filled\nTone: 24K\nSize: 1.5mm\nTheme: Mariner Chain\n\n",
  tags: [],
  msrpDollars: 11.09,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:58:58.073Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
